import { HttpMethod, HttpOption } from '@/utils/http-client'
import { LoanRequest } from '@/api/model/credit'

export class CreditAPIConstant {
    queryLoanPage = (data: LoanRequest): HttpOption => ({
        url: '/fundcloud/loan/query-loanPage',
        method: HttpMethod.POST,
        data
    })
}
